import { render, staticRenderFns } from "./FileDownloadButton.vue?vue&type=template&id=3edebedd&scoped=true"
import script from "./FileDownloadButton.vue?vue&type=script&lang=js"
export * from "./FileDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadButton.vue?vue&type=style&index=0&id=3edebedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edebedd",
  null
  
)

export default component.exports